import {
  addDays,
  eachDayOfInterval,
  endOfMonth,
  endOfWeek,
  format,
  startOfMonth,
  startOfWeek,
} from 'date-fns';
import { useMemo } from 'react';
import { getDateFnsLocale } from '../utils';

export const useMonthGrid = (viewDate: Date) => {
  const calendarDays = useMemo(
    () =>
      eachDayOfInterval({
        start: startOfWeek(startOfMonth(viewDate), { weekStartsOn: 1 }),
        end: endOfWeek(endOfMonth(viewDate), { weekStartsOn: 1 }),
      }),
    [viewDate]
  );

  const weekDayLabels = useMemo(() => {
    const locale = getDateFnsLocale();
    const weekStart = startOfWeek(new Date(), { weekStartsOn: 1 });

    return Array.from({ length: 7 }, (_, index) =>
      format(addDays(weekStart, index), 'EEEEEE', { locale }).toUpperCase()
    );
  }, []);

  return useMemo(() => ({ calendarDays, weekDayLabels }), [calendarDays, weekDayLabels]);
};
